// @flow
import * as types from './mutation-types'
import type { TripState } from './index'
import type { TripsPage } from '../../../types/trips-page'
import { formatStoreDate } from '../../../utils/date'

export default {
  [types.SET_TRIPS_PAGE]: (state: TripState, value: TripsPage): void => {
    state.tripsPage = value
  },
  [types.SET_TRIPS_FILTER_MONTHS]: (state: TripState, value: string[]): void => {
    state.filterCheckinMonthOptions = value
  },
  [types.SET_PAGE_SIZE]: (state: TripState, number: number): void => {
    state.pageSize = number
    if (state.tripsPage) {
      let noPages = Math.ceil(state.tripsPage.count / number)
      if (state.pageNumber >= noPages) {
        state.pageNumber = noPages - 1
      }
    }
  },
  [types.SET_PAGE_NUMBER]: (state: TripState, number: number): void => {
    state.pageNumber = number
  },
  [types.SET_FILTER_INVOICE_NUMBER]: (state: TripState, value: string): void => {
    state.filterInvoiceNumber = value
  },
  [types.SET_FILTER_CHECKIN_MONTH]: (state: TripState, value: string): void => {
    state.filterCheckinMonth = value
  },
  [types.SET_FILTER_CHECKIN_DATE_FROM]: (state: TripState, value: ?Date): void => {
    state.filterCheckinDateFrom = formatStoreDate(value)
  },
  [types.SET_FILTER_CHECKIN_DATE_TO]: (state: TripState, value: ?Date): void => {
    state.filterCheckinDateTo = formatStoreDate(value)
  },
  [types.SET_ORDER_BY]: (state: TripState, orderBy: ?string): void => {
    state.orderBy = orderBy
  },
  [types.SET_ORDER_DIRECTION]: (state: TripState, orderDirection: ?string): void => {
    state.orderDirection = orderDirection
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/trip/mutations.js